import { render } from "./PropertyPanel.vue?vue&type=template&id=22aa1d93&scoped=true"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"

import "./PropertyPanel.vue?vue&type=style&index=0&id=22aa1d93&lang=css"
import "./PropertyPanel.vue?vue&type=style&index=1&id=22aa1d93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aa1d93"]])

export default __exports__